import { render } from "./ApresentarCidade.vue?vue&type=template&id=119cf630&ts=true"
import script from "./ApresentarCidade.vue?vue&type=script&lang=ts"
export * from "./ApresentarCidade.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__